"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportFromCartButton = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ImportFromCartButton = function (props) { return (React.createElement(sok_ui_1.Column, { small: 6, className: 'import-button' },
    React.createElement(sok_ui_1.Button, { size: 'medium', color: 'green', disabled: props.disabled, onClick: props.onClick, text: (0, translation_1.getLocalization)('userfront/order/step3/importfromcart') }))); };
exports.ImportFromCartButton = ImportFromCartButton;
